import utpFirstBg from './assets/utp-first-bg.png';
import utpSecondBg from './assets/utp-second-bg.png';
import utpFirstFront from './assets/utp-first-front.png';
import utpSecondFront from './assets/utp-second-front.png';

export const UTP = [
  {
    title: 'Покажем количество конкурирующих объявлений с продвижением и без него',
    imageBg: utpFirstBg,
    imageFront: utpFirstFront,
  },
  {
    title: 'Используйте разброс ставок конкурентов, чтобы опередить всех',
    imageBg: utpSecondBg,
    imageFront: utpSecondFront,
    frontMessage: 'Ваша ставка выше 80% из них',
  },
];
